/**
 * Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 * All information herein, source code below as well as the Morpheus system itself and all related
 * software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 * Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 * is prohibited.
 */

import { ActionTree } from 'vuex'
import { RootState } from '../../types'
import { AuthState } from './types'
import { authorizeAdmin, logoutAdmin } from '../../../services/auth-client'
import { AdminLogin, TokenData } from '../../../types'

export const actions: ActionTree<AuthState, RootState> = {
  login ({ commit }, admin: AdminLogin): Promise<TokenData> {
    return new Promise((resolve, reject) => {
      authorizeAdmin(admin)
        .then(({ token, jwtIatTimestamp, jwtExpTimestamp }) => {
          commit('login', { token, jwtIatTimestamp, jwtExpTimestamp })
          resolve({ token, jwtIatTimestamp, jwtExpTimestamp })
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  logout ({ commit }): Promise<any> {
    return new Promise((resolve, reject) => {
      logoutAdmin()
        .then((response) => {
          commit('logout')
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
